import usePositions from '@ubeya/shared/hooks/account/usePositions';
import usePositionsGroups from '@ubeya/shared/hooks/account/usePositionsGroups';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { Select as BaseSelect } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { generatePositionOptions } from 'shared/utils/positions';
import { PositionSelectFieldOption } from '../AddNewSelectors/PositionSelectFieldOption';

const Select = styled(BaseSelect)`
  .select-chips {
    min-height: 46px;
  }

  .select-arrow {
    top: 16px;
    right: 14px;
  }
`;

const PositionSelect = ({ selectedPositions, handlePositionChange, includePositionGroups = false }) => {
  const { t } = useContext(ConfigContext);
  const { positionsOptions: defaultPositionsOptions } = usePositions();
  const { positionsGroups } = usePositionsGroups();

  const positionsOptions = useMemo(
    () =>
      generatePositionOptions({
        includePositionGroups,
        positionsOptions: defaultPositionsOptions,
        positionsGroups,
        t
      }),
    [defaultPositionsOptions, includePositionGroups, positionsGroups, t]
  );

  return (
    <Select
      searchable={selectedPositions.length === 0}
      options={positionsOptions}
      value={selectedPositions}
      onChange={handlePositionChange}
      isMulti
      usePortal
      formatOption={({ value, label, ...rest }) => ({
        value,
        label: <PositionSelectFieldOption value={value} label={label} />,
        ...rest
      })}
    />
  );
};

export default PositionSelect;
